// "Yeni kişiler" → "Hastaya bağla": hasta arama + bağlama (POST /contacts/link).
// Hasta arama, randevu formundaki kalıpla aynı: FormAutocomplete + patients/list (gecikmeli).

import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { LinkRounded as LinkIcon } from "@mui/icons-material";
import { FormAutocomplete, FormTextField, formatPhoneDisplay } from "../../components/atoms";
import { FormDialog } from "../../components/organisms";
import { useListPatientsMutation } from "../../store/secretaryApi";
import { COLORS, TYPO } from "../../styles/uiConstants";
import useTerms from "../../hooks/useTerms";

const patientLabel = (p) => {
  const name = `${p?.name || ""} ${p?.surname || ""}`.trim();
  const phone = p?.tellNo ? ` · ${formatPhoneDisplay(p.tellNo)}` : "";
  return `${name}${phone}`.trim();
};

/**
 * @param {boolean} open
 * @param {() => void} onClose
 * @param {object|null} contact
 * @param {(patientId: string) => Promise<void>} onLink
 * @param {boolean} linking
 * @param {string} token
 * @param {object} palette
 */
export default function LinkPatientDialog({ open, onClose, contact, onLink, linking, token, palette }) {
  const terms = useTerms();
  const [listPatients, { isLoading }] = useListPatientsMutation();
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (open) {
      setQuery("");
      setSelected(null);
    }
  }, [open]);

  useEffect(() => {
    if (!open || !token) return undefined;
    const handle = setTimeout(async () => {
      try {
        const res = await listPatients({ token, query, page: 1, limit: 30 }).unwrap();
        setOptions(res?.data?.patients || []);
      } catch (_e) {
        // Arama sırasında sessizce geç
      }
    }, 350);
    return () => clearTimeout(handle);
  }, [open, token, query, listPatients]);

  const phone = formatPhoneDisplay(contact?.phone) || contact?.phone || "";

  return (
    <FormDialog
      open={open}
      onClose={onClose}
      icon={<LinkIcon />}
      title={`${terms.patientDat} bağla`}
      subtitle={[contact?.profileName, phone].filter(Boolean).join(" · ")}
      maxWidth="xs"
      loading={linking}
      submitLabel="Bağla"
      loadingLabel="Bağlanıyor..."
      submitDisabled={!selected}
      onSubmit={() => selected && onLink(selected._id)}
    >
      <Typography sx={{ fontSize: TYPO.body, color: COLORS.slate600, lineHeight: 1.6 }}>
        Bu numaradan gelen mesajlar seçtiğiniz {terms.patientGenLower} konuşmasına taşınır ve bundan sonraki mesajlar
        doğrudan orada görünür.
      </Typography>
      <FormAutocomplete
        options={options}
        value={selected}
        loading={isLoading}
        filterOptions={(x) => x}
        getOptionLabel={patientLabel}
        isOptionEqualToValue={(o, v) => o?._id === v?._id}
        noOptionsText={`${terms.patient} bulunamadı`}
        loadingText={`${terms.patients} yükleniyor...`}
        onInputChange={(_, value, reason) => {
          if (reason === "input") setQuery(value);
          if (reason === "clear") setQuery("");
        }}
        onChange={(_, v) => setSelected(v || null)}
        renderInput={(params) => (
          <FormTextField
            {...params}
            palette={palette}
            label={terms.patient}
            placeholder={`${terms.patient} adı veya TC ile ara`}
            autoFocus
          />
        )}
      />
    </FormDialog>
  );
}
